import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/planning/issues/:issueId");

export const Route = createFileRoute("/planning/issues/$issueId")({
  head: () => ({
    meta: [
      { title: "Planning issue — LevelLoad" },
      { name: "description", content: "The rows behind one finding reported by the solve." },
      { property: "og:title", content: "Planning issue — LevelLoad" },
      {
        property: "og:description",
        content: "The rows behind one finding reported by the solve.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
